import { useEffect, useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { overrideCssVars } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { z } from 'zod';

import { popupDesigns } from 'components/TemplatesStudio/DesignsMetadata/popups.metadata';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const PopupDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();
  const { setDisplayPopupPreview } = useTemplateStudioState();

  const popupRatio = useWatch({
    control,
    name: 'popup.popupRatio'
  });

  useEffect(() => {
    setDisplayPopupPreview(true);
    return () => {
      setDisplayPopupPreview(false);
    };
  }, []);

  const designs = useMemo(() => {
    return Object.values(popupDesigns);
  }, []);

  useEffect(() => {
    const cssMappingOverride = {
      '--popup-banner-ratio': popupRatio
    };
    overrideCssVars(cssMappingOverride, document);
  }, [popupRatio]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="popup.popupRatio"
        />
      ))}
    </>
  );
};
